import CoverageOptionsStep from "components/steps/CoverageOptionsStep";

const FavPlanCoverageOptionsStep = () => <CoverageOptionsStep />;

export default FavPlanCoverageOptionsStep;
